import {useMutation, useQuery} from '@tanstack/react-query';

import {RQ_ACTIVE_PROMOCODE, RQ_GET_PROMOCODE_API, RQ_PROMOCODE_Delete, RQ_PROMOCODE_LOOKUP_BY_ID, RQ_PROMOCODE_REGISTER, RQ_UPDATE_PROMOCODE} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetPromocodeAPI = token => {
  return useQuery({
    queryKey: ['rq_get_all_promocode', token],
    queryFn: async () => {
      if (!token) {
        throw new Error('Token is required');
      }
      const response = await rqCreateRequest(
        RQ_GET_PROMOCODE_API,
        null,
        token,
        null,
      );
      return response || [];
    },
    enabled: Boolean(token),
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RQGetActivePromocodeAPI = token => {
  return useQuery({
    queryKey: ['rq_get_active_promocode', token],
    queryFn: async () => {
      if (!token) {
        throw new Error('Token is required');
      }
      const response = await rqCreateRequest(
        RQ_ACTIVE_PROMOCODE,
        null,
        token,
        null,
      );
      return response || [];
    },
    enabled: Boolean(token),
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RQGetPromocodeByIdAPI = (token, id) => {
  return useQuery({
    queryKey: ['rq_get_promocode_by_id', id, token],
    queryFn: async () => {
      if (!token) {
        throw new Error('Token is required');
      }
      if (!id) {
        throw new Error('Promocode ID is required');
      }

      const url = RQ_PROMOCODE_LOOKUP_BY_ID.url.replace('<%= id %>', id);
      const response = await rqCreateRequest(
        {...RQ_PROMOCODE_LOOKUP_BY_ID, url},
        null,
        token,
        null,
      );
      return response;
    },
    enabled: Boolean(token && id),
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RQPromocodeRegistrationAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_register_promocode'],
    mutationFn: async ({token, formData}) => {
      if (!token) {
        throw new Error('Token is required');
      }
      return rqCreateRequest(
        RQ_PROMOCODE_REGISTER,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RQUpdatePromocodeAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_promocode'],
    mutationFn: async ({token, formData, id}) => {
      if (!token) {
        throw new Error('Token is required');
      }
      if (!id) {
        throw new Error('Promocode ID is required');
      }
      const url = RQ_UPDATE_PROMOCODE.url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_UPDATE_PROMOCODE, url},
          formData,
          token,
          null,
        );

        return response;
      } catch (error) {
        console.error('Error updating promocode:', error);
        throw error;
      }
    },
    ...options,
  });
};

export const RQDeletePromocodeAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_delete_promocode'],
    mutationFn: async ({token, id}) => {
      if (!token) {throw new Error('Token is required');}
      const url = RQ_PROMOCODE_Delete .url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_PROMOCODE_Delete, url},
          null, 
          token,
          null, 
          null, 
        );

        return response;
      } catch (error) {
        console.error('Error deleting Promocode:', error);
        throw error;
      }
    },
    ...options,
  });
};
